
import { head, find, partition, choose, ofArray, collect as collect_1, truncate, exists, sumBy as sumBy_1, item, skip, sort, singleton, tryFind as tryFind_1, tryPick, filter, length, map, toArray, cons, iterate, isEmpty, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { defaultOf, stringHash, compareArrays, comparePrimitives, equals, Exception, createAtom } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { SimSubTab, RightTab, WaveSimModel, SpinPayload, Model, TTMsg, showLibrarySheets_, Msg } from "../Model/ModelType.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { warn, error, out } from "../Shared/Log.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { FSharpRef, toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { containsKey, toList as toList_1, ofList, toSeq, FSharpMap__get_Count, toArray as toArray_1, count as count_2, tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Window$ } from "./WaveSim/WaveSlice.js";
import { needFetching } from "./WaveSim/WaveData.js";
import { staleCount, tryDrawn } from "./WaveSim/WaveDrawn.js";
import { selectedWaves } from "./WaveSim/WaveSimStyle.js";
import { simulateModel, getWSModel, designOf, sidecarFetchInFlight } from "./ModelHelpers.js";
import { simDigest, simPorts, errorOfFrame, simRead, simLog, simBuild, simRun, simEnd, sendDesign, connect, connectionState } from "../Interface/SidecarClient.js";
import { describeHeld } from "../Interface/PortData.js";
import { startCircuitSimulation, simCache, getFastSim } from "../Simulator/Simulator.js";
import { sheetSliceOf, waveIndicesOfDesign, tryOfInstanceCached } from "../Simulator/FastSim/PortView.js";
import { tryItem, item as item_1, equalsWith, map as map_1 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { zip, indexed, filter as filter_1, append, head as head_1, empty as empty_1, singleton as singleton_1, delay, toList, sumBy, map as map_2, collect, toArray as toArray_2 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { SimulatedDesign__SheetOfInstance_1A26531, SimulatedDesign__SubSheetsOf_Z721C83C5, FastSimulation__get_SimulatedTopSheet } from "../Simulator/SimTypes.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { runFastSimulation } from "../Simulator/FastSim/FastRun.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { split, concat, interpolate, printf, toText, join } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { DrawModelType_SheetT_Model__Model_get_GetSelectedCanvasState, DrawModelType_SheetT_Model__Model_GetCanvasState } from "../DrawBlock/Sheet.js";
import { simpleDesignOfLoadedComponents } from "../Simulator/CanvasExtractor.js";
import { Convert_serialize } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";
import { XYPos, WSConfig as WSConfig_1, SimpleDesign, SimpleSheet_$reflection } from "../Common/CommonTypes.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { min, tryParse as tryParse_1, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { refreshButtonAction } from "./WaveSim/WaveSimTop.js";
import { parse, tryParse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { List_distinctBy, List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { makeSimDataSelected } from "./TruthTable/TruthTableView.js";
import { Constants_maxArraySize, tryGetSimData, setSimErrorFeedback } from "./SimulationView.js";
import { setClkCycleMsg } from "./WaveSim/WaveSimNavigation.js";
import { openFileInProject, openProjectFromPath } from "./MenuHelpers.js";
import { Result_IsOk, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { DrawModelType_SheetT_ArrayDirection, DrawModelType_BusWireT_Msg, DrawModelType_SymbolT_Msg, DrawModelType_SheetT_Msg, DrawModelType_SheetT_KeyboardMsg } from "../Model/DrawModelType.js";
import { shortcuts } from "../Common/KeyTypes.js";
import { actionOf } from "./KeyBindings.js";
import { recentJson } from "../Simulator/SimLog.js";
import { extractFastSimulationOutput } from "../Simulator/FastSim/FastExtract.js";
import { fromUInt32, toUInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { render } from "../Simulator/SimDigest.js";
import { debugLevel } from "../Interface/JSHelpers.js";

let latestModel = undefined;

let latestDispatch = undefined;

let waitingForRender = empty();

export let forceViewException = createAtom(false);

/**
 * Fire the renderer's exception boundary on purpose, so that what it records - and what Info ->
 * Bug Reports then shows - can be checked rather than assumed. One kind per way an exception can
 * get out of Issie's own code; see the boundary in Renderer.fs. Reached from the Development
 * menu and from `drive.js send forceException <kind>`.
 * 
 * "view" does not come back: from the render this causes onwards the application is the crash
 * page, which is what a view that throws really does.
 */
export function forceException(kind, dispatch) {
    switch (kind) {
        case "update": {
            dispatch(new Msg(/* ExecFuncInMessage */ 116, [(_arg, _arg_1) => {
                throw new Exception("forced exception from update");
            }, dispatch]));
            return "threw inside update";
        }
        case "view": {
            forceViewException(true);
            dispatch(new Msg(/* UpdateModel */ 41, [(m) => Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, showLibrarySheets_)(m.ShowLibrarySheets)(m)]));
            return "threw inside the view - the app is now the crash page";
        }
        case "promise": {
            Promise.reject(new Exception("forced rejection with nothing awaiting it"));
            return "rejected a promise nothing is awaiting";
        }
        default: {
            window.setTimeout(() => {
                throw new Exception("forced exception from a callback");
            }, 0);
            return "threw inside a browser callback";
        }
    }
}

/**
 * Choose which simulator runs, throwing away anything currently simulating.
 * 
 * The two backends share nothing - not a step array, not a built simulation - so a switch
 * cannot leave one running and hand it to the other. Everything that holds a simulation is
 * therefore ended first: the step simulator, the waveform simulator and the truth table, which
 * between them are what `ModelHelpers.simulationIsOpen` reports. The flag is then set, and the
 * next simulation the user starts is built by whichever backend is now chosen.
 * 
 * Here rather than in the menu because both the Development menu and the `simulateIn` harness
 * command need it, and a switch that stopped simulations in one path and not the other would be
 * a good way to end up with a waveform viewer reading a simulation nobody is running.
 */
export function setSimulateInRenderer(inRenderer, dispatch) {
    dispatch(Msg.EndSimulation);
    dispatch(Msg.EndWaveSim);
    dispatch(new Msg(/* TruthTableMsg */ 32, [TTMsg.CloseTruthTable]));
    dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, inRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
    out(inRenderer ? "simulation will now run IN THE RENDERER (deprecated - for development only)" : "simulation will now run in the .NET sidecar");
}

let lastBenchmarkSim = undefined;

/**
 * Called from the view wrapper, before the view runs.
 */
export function recordModel(model) {
    latestModel = model;
}

/**
 * Called from the view wrapper, after the view has produced its elements.
 * 
 * The callbacks run on the next animation frame rather than immediately: the view returning means
 * React has been given the new elements, not that the DOM holds them, and a caller waiting for a
 * render wants the state it can then read to be the state it was waiting for.
 */
export function renderDone() {
    if (isEmpty(waitingForRender)) {
    }
    else {
        const callbacks = waitingForRender;
        waitingForRender = empty();
        window.requestAnimationFrame((_arg) => {
            iterate((f) => {
                f();
            }, callbacks);
        });
    }
}

function onNextRender(callback) {
    waitingForRender = cons(callback, waitingForRender);
}

function sheetNames(model) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        return [];
    }
    else {
        return toArray(map((ldc) => ldc.Name, matchValue.LoadedComponents));
    }
}

function circuitCheckOf(model) {
    const matchValue = model.CircuitCheck.Verdict;
    if (matchValue != null) {
        const copyOfStruct = matchValue[0];
        if (copyOfStruct.tag === 1) {
            return "doesNotBuild";
        }
        else if (copyOfStruct.fields[0]) {
            return "buildsAndIsSynchronous";
        }
        else {
            return "buildsAndIsCombinational";
        }
    }
    else {
        return "notYetChecked";
    }
}

function state() {
    let project, option_1, openSheet, option_4, sheets, rightTab, simSubTab, simulateIn;
    if (latestModel != null) {
        const model = latestModel;
        return (project = defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? option_1.ProjectPath : undefined), ""), (openSheet = defaultArg((option_4 = model.CurrentProj, (option_4 != null) ? option_4.OpenFileName : undefined), ""), (sheets = sheetNames(model), (rightTab = toString(model.RightPaneTabVisible), (simSubTab = toString(model.SimSubTabVisible), (simulateIn = (model.SimulateInRenderer ? "renderer" : "sidecar"), {
            circuitCheck: circuitCheckOf(model),
            openSheet: openSheet,
            popupOpen: model.PopupViewFunc != null,
            project: project,
            ready: true,
            rightTab: rightTab,
            sheets: sheets,
            simSubTab: simSubTab,
            simulateIn: simulateIn,
            stepSimulationOpen: !equals(model.CurrentStepSimulationStep, undefined),
            truthTableOpen: !equals(model.CurrentTruthTable, undefined),
            waveSimSheet: defaultArg(model.WaveSimSheet, ""),
        }))))));
    }
    else {
        return {
            ready: false,
        };
    }
}

function waveState() {
    let sheet_1, state_1, selected, detailed, missing, drawn, stale;
    if (latestModel != null) {
        const model = latestModel;
        let matchValue;
        const option_1 = model.WaveSimSheet;
        matchValue = ((option_1 != null) ? tryFind(option_1, model.WaveSim) : undefined);
        if (matchValue != null) {
            const ws = matchValue;
            const window$ = new Window$(ws.StartCycle, ws.SamplingZoom, ws.ShownCycles);
            const handles = map((wi) => wi.SimArrayIndex, ws.SelectedWaves);
            return (sheet_1 = defaultArg(model.WaveSimSheet, ""), (state_1 = toString(ws.State), (selected = (length(ws.SelectedWaves) | 0), (detailed = (count_2(ws.WaveDetails) | 0), (missing = (length(needFetching(handles, window$)) | 0), (drawn = (length(filter((wi_1) => (tryDrawn(wi_1.SimArrayIndex) != null), ws.SelectedWaves)) | 0), (stale = (staleCount(ws, selectedWaves(ws)) | 0), {
                cursor: ws.CursorExactClkCycle,
                detailed: detailed,
                drawn: drawn,
                drawnStart: defaultArg(tryPick((wi_2) => {
                    const option_4 = tryDrawn(wi_2.SimArrayIndex);
                    if (option_4 != null) {
                        return option_4.Spec.Window.StartSample;
                    }
                    else {
                        return undefined;
                    }
                }, ws.SelectedWaves), -1),
                fetchInProgress: sidecarFetchInFlight(model),
                inRenderer: model.SimulateInRenderer,
                lastClock: ws.WSConfig.LastClock,
                missing: missing,
                open_: true,
                samplingZoom: ws.SamplingZoom,
                selected: selected,
                sheet: sheet_1,
                shownCycles: ws.ShownCycles,
                spinner: model.SpinnerPayload != null,
                stale: stale,
                startCycle: ws.StartCycle,
                state: state_1,
            })))))));
        }
        else {
            return {
                open_: false,
            };
        }
    }
    else {
        return {
            open_: false,
        };
    }
}

function sidecar() {
    let matchValue;
    const patternInput = connectionState();
    return {
        connected: patternInput[0],
        pending: patternInput[1],
        ports: describeHeld(getFastSim()),
        topPorts: (matchValue = tryOfInstanceCached(getFastSim())(empty()), (matchValue != null) ? length(matchValue.ViewPorts) : -1),
    };
}

function simRefs() {
    let copyOfStruct, cached, truthTable, copyOfStruct_1, waveSimSheets, option_1, usedHeapMB;
    const comps = (fs) => (fs.FCompsByIndex.length | 0);
    const inModel = ((latestModel != null) ? ((latestModel.CurrentStepSimulationStep != null) ? ((copyOfStruct = latestModel.CurrentStepSimulationStep, (copyOfStruct.tag === 0) ? comps(copyOfStruct.fields[0].FastSim) : 0)) : 0) : 0) | 0;
    return (cached = (comps(simCache().FastSim) | 0), (truthTable = (((latestModel != null) ? ((latestModel.CurrentTruthTable != null) ? ((copyOfStruct_1 = latestModel.CurrentTruthTable, (copyOfStruct_1.tag === 0) ? comps(copyOfStruct_1.fields[0].TableSimData.FastSim) : 0)) : 0) : 0) | 0), (waveSimSheets = defaultArg((option_1 = latestModel, (option_1 != null) ? map_1((tuple) => tuple[0], toArray_1(option_1.WaveSim)) : undefined), []), (usedHeapMB = (~~((performance.memory.usedJSHeapSize) / 1048576) | 0), {
        cached: cached,
        heapLimitMB: ~~((performance.memory.jsHeapSizeLimit) / 1048576),
        inModel: inModel,
        truthTable: truthTable,
        usedHeapMB: usedHeapMB,
        waveSimSheets: waveSimSheets,
    }))));
}

function simStats() {
    let sheet, array_1, array_3, option_1;
    const fs_1 = tryFind_1((fs) => (fs.FCompsByIndex.length > 0), singleton(simCache().FastSim));
    if (fs_1 != null) {
        const fs_2 = fs_1;
        const widths = toArray_2(collect((fc) => map_2((io) => (io.Width | 0), fc.Outputs), fs_2.FCompsByIndex));
        return (sheet = FastSimulation__get_SimulatedTopSheet(fs_2), {
            comps: fs_2.FCompsByIndex.length,
            heapStepMB: (fs_2.StepCost.HeapBytes * fs_2.MaxArraySize) / 1000000,
            live: true,
            maxArraySize: fs_2.MaxArraySize,
            numStepArrays: fs_2.NumStepArrays,
            outputPorts: widths.length,
            outputPortsLe32: (array_1 = widths.filter((w) => (w <= 32)), array_1.length),
            outputPortsWide: (array_3 = widths.filter((w_1) => (w_1 > 32)), array_3.length),
            sheet: sheet,
            syncComps: fs_2.FClockedComps.length,
            typedArrayMB: (fs_2.StepCost.TypedArrayBytes * fs_2.MaxArraySize) / 1000000,
            waves: defaultArg((option_1 = latestModel, (option_1 != null) ? sumBy((tupledArg) => (FSharpMap__get_Count(tupledArg[1].WaveDetails) | 0), toSeq(option_1.WaveSim), {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) : undefined), 0),
        });
    }
    else {
        return {
            live: false,
        };
    }
}

function timeRuns(fs, steps) {
    let clo;
    const all = map((_arg) => {
        fs.ClockTick = 0;
        const t0 = getTimeMs();
        runFastSimulation(undefined, steps, fs);
        return getTimeMs() - t0;
    }, toList(rangeDouble(1, 1, 10)));
    const times = sort(skip(3, all), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const median = item(~~(length(times) / 2), times);
    const series = join(", ", map((clo = toText(printf("%.1f")), clo), all));
    const comps = fs.FCompsByIndex.length | 0;
    const heapMB = (performance.memory.usedJSHeapSize) / 1048576;
    return (((((`{"sheet": "${FastSimulation__get_SimulatedTopSheet(fs)}", "comps": ${comps}, "syncComps": ${fs.FClockedComps.length}, `) + (`"ordered": ${fs.FOrderedComps.length}, "stepArrays": ${fs.NumStepArrays}, `)) + (`"maxArraySize": ${fs.MaxArraySize}, "typedArrayMB": ${interpolate("%.1f%P()", [(fs.StepCost.TypedArrayBytes * fs.MaxArraySize) / 1000000])}, `)) + (`"heapStepMB": ${interpolate("%.1f%P()", [(fs.StepCost.HeapBytes * fs.MaxArraySize) / 1000000])}, "usedHeapMB": ${interpolate("%.0f%P()", [heapMB])}, `)) + (`"steps": ${steps}, "medianMs": ${interpolate("%.2f%P()", [median])}, "compStepPerMs": ${interpolate("%.0f%P()", [(comps * steps) / median])}, `)) + concat("\"seriesMs\": [", series, "]}");
}

function currentDesign(model) {
    let project, ldcs, tupledArg;
    const option_1 = model.CurrentProj;
    if (option_1 != null) {
        return (project = option_1, (ldcs = ((tupledArg = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet), designOf(project, tupledArg[0], tupledArg[1]))), [ldcs, simpleDesignOfLoadedComponents(ldcs)]));
    }
    else {
        return undefined;
    }
}

export function sendDesignToSidecar(model, _dispatch) {
    let pr;
    const t0 = getTimeMs();
    const matchValue = currentDesign(model);
    if (matchValue != null) {
        const design = matchValue[1];
        const t1 = getTimeMs();
        const sheetJsons = map((value) => Convert_serialize(value, createTypeInfo(SimpleSheet_$reflection())), design.Sheets);
        const totalChars = sumBy_1((str) => (str.length | 0), sheetJsons, {
            GetZero: () => 0,
            Add: (x, y) => ((x + y) | 0),
        }) | 0;
        const t2 = getTimeMs();
        (pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (sendDesign(design.TopSheet, sheetJsons).then((_arg_1) => {
            const t3 = getTimeMs();
            out(((((`design -> sidecar (${length(design.Sheets)} sheets): `) + (`reduce+convert ${interpolate("%.2f%P()", [t1 - t0])}ms, `)) + (`serialise ${interpolate("%.2f%P()", [t2 - t1])}ms (${totalChars} chars), `)) + (`round trip incl dotnet deserialise ${interpolate("%.2f%P()", [t3 - t2])}ms, `)) + (`total ${interpolate("%.2f%P()", [t3 - t0])}ms`));
            out(concat("sidecar replied: ", _arg_1));
            return Promise.resolve();
        })))))), pr.catch((e) => {
            error(concat("sidecar design test: ", e.message));
        }));
    }
    else {
        error("sidecar design test: open a project first");
    }
}

const sidecarRunName = "Running simulation on the .NET sidecar...";

/**
 * A long simulation run ON THE SIDECAR, reported through the same progress bar as a local run.
 * The loop is chunked SimRun requests with a time budget each; after every reply it updates
 * the bar and re-checks ownership on the model, so Cancel takes effect within one chunk.
 * The wave-cursor nudge in CancelWaveSimulation touches only the LOCAL simulation and is a
 * no-op when none exists.
 */
export function runOnSidecarWithProgress(cycles, arraySize, topSheet, model, dispatch) {
    let name, pr_3;
    const matchValue = currentDesign(model);
    if (matchValue != null) {
        const wholeDesign = matchValue[1];
        let design;
        if (topSheet == null) {
            design = wholeDesign;
        }
        else if ((name = topSheet, exists((sh) => (sh.SheetName === name), wholeDesign.Sheets))) {
            const name_1 = topSheet;
            design = (new SimpleDesign(name_1, wholeDesign.Sheets));
        }
        else {
            const name_2 = topSheet;
            warn(concat("sidecarRun: no sheet called ", name_2, ", simulating ", wholeDesign.TopSheet));
            design = wholeDesign;
        }
        const sheetJsons = map((value) => Convert_serialize(value, createTypeInfo(SimpleSheet_$reflection())), design.Sheets);
        const started = getTimeMs();
        const setBar = (toDo) => {
            dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, new SpinPayload(true, sidecarRunName, max(0, toDo), cycles), m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
        };
        const clearBarIfOurs = () => {
            dispatch(new Msg(/* UpdateModel */ 41, [(m_1) => {
                const matchValue_1 = m_1.SpinnerPayload;
                let matchResult, p_1;
                if (matchValue_1 != null) {
                    if (matchValue_1.Name === sidecarRunName) {
                        matchResult = 0;
                        p_1 = matchValue_1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return new Model(m_1.WindowWidth, m_1.KeyFocusPane, m_1.RunAfterRenderWithSpinner, m_1.UserData, m_1.WaveSim, m_1.WaveSimSheet, m_1.UISheetTrail, m_1.Spinner, m_1.Sheet, m_1.IsLoading, m_1.LastChangeCheckTime, m_1.LastSimulatedCanvasState, m_1.LastDetailedSavedState, m_1.CurrentSelected, m_1.LastSelectedIds, m_1.LastUsedDialogWidth, m_1.SelectedComponent, m_1.CurrentStepSimulationStep, m_1.CurrentTruthTable, m_1.TTConfig, m_1.RightPaneTabVisible, m_1.SimSubTabVisible, m_1.CircuitCheck, m_1.Hilighted, m_1.Clipboard, m_1.LastCreatedComponent, m_1.SavedSheetIsOutOfDate, m_1.PendingDragAddition, m_1.DragPlacement, m_1.ProjectBrowser, m_1.TopSheetChoiceDeclined, m_1.ComponentLibraries, m_1.OpenLibrary, m_1.CatalogueSearch, m_1.ArrayCopiesTyped, m_1.SimulateInRenderer, m_1.SidecarSession, m_1.ProbeRead, m_1.SidecarInFlight, m_1.SidecarBuildEndedMs, m_1.SidecarRunEndedMs, m_1.StepRunTarget, m_1.FetchedData, m_1.FetchedStructure, m_1.FailedFetch, m_1.StimulusGeneration, m_1.CurrentViewport, m_1.ViewportChangedAtMs, m_1.WaveScrollSettling, m_1.WaveScrollSerial, m_1.ShowLibrarySheets, m_1.SuppressErrorPopups, m_1.OpenedLibrarySheets, m_1.ReadOnlyBaseline, m_1.CurrentProj, m_1.PopupViewFunc, undefined, m_1.PopupDialogData, m_1.Notifications, m_1.TopMenuOpenState, m_1.SheetMenuPinned, m_1.DividerDragMode, m_1.WaveSimViewerWidth, m_1.ConnsOfSelectedWavesAreHighlighted, m_1.Pending, m_1.UIState, m_1.BuildVisible, m_1.CodeEditorState);
                    default:
                        return m_1;
                }
            }]));
        };
        const finishSession = (epoch) => {
            let pr;
            (pr = simEnd(epoch), pr.then((value_2) => {
            }));
        };
        const chunk = (epoch_1, chunkCount) => {
            let pr_2, pr_1;
            (pr_2 = ((pr_1 = simRun(epoch_1, cycles, 100), pr_1.then((reply) => {
                if (reply.startsWith("{\"error")) {
                    clearBarIfOurs();
                    error(concat("sidecarRun: ", reply));
                }
                else {
                    const tick = ~~JSON.parse(reply).clockTick | 0;
                    const finished = reply.indexOf("\"done\":true") >= 0;
                    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg) => {
                        const matchValue_2 = model_1.SpinnerPayload;
                        let matchResult_1, p_3;
                        if (matchValue_2 != null) {
                            if (matchValue_2.Name === sidecarRunName) {
                                matchResult_1 = 0;
                                p_3 = matchValue_2;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                if (finished) {
                                    clearBarIfOurs();
                                    const ms = getTimeMs() - started;
                                    out((`sidecarRun: ${cycles} cycles in ${interpolate("%.0f%P()", [ms])}ms over ${chunkCount} chunks `) + (`(${interpolate("%.2f%P()", [cycles / ms])} cycles/ms) - see simLog/sidecarSimLog for the per-chunk records`));
                                    finishSession(epoch_1);
                                }
                                else {
                                    setBar(cycles - tick);
                                    chunk(epoch_1, chunkCount + 1);
                                }
                                break;
                            }
                            case 1: {
                                out(`sidecarRun: cancelled at cycle ${tick} after ${chunkCount} chunks`);
                                finishSession(epoch_1);
                                break;
                            }
                        }
                    }, dispatch]));
                }
            }))), pr_2.catch((e) => {
                clearBarIfOurs();
                error(concat("sidecarRun: ", e.message));
            }));
        };
        (pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (sendDesign(design.TopSheet, sheetJsons).then((_arg_2) => (simBuild(arraySize).then((_arg_3) => {
            const built = _arg_3;
            if (built.indexOf("error") >= 0) {
                error(concat("sidecarRun: ", built));
                return Promise.resolve();
            }
            else {
                setBar(cycles);
                chunk((function (t) { try { return JSON.parse(t).epoch || 0 } catch (e) { return 0 } })(built), 1);
                return Promise.resolve();
            }
        })))))))), pr_3.catch((e_1) => {
            error(concat("sidecarRun: ", e_1.message));
        }));
    }
    else {
        error("sidecarRun: open a project first");
    }
}

const commands = ofArray([["forceException", (arg) => ((_arg) => ((dispatch) => forceException(arg, dispatch)))], ["endSimulation", (_arg_1) => ((_arg_2) => ((dispatch_1) => {
    dispatch_1(Msg.EndSimulation);
    lastBenchmarkSim = undefined;
    return "ended the step simulation";
}))], ["simulateIn", (arg_1) => ((model) => ((dispatch_2) => {
    const matchValue = arg_1.trim().toLocaleLowerCase();
    switch (matchValue) {
        case "": {
            const arg_2 = model.SimulateInRenderer ? "renderer" : "sidecar";
            return toText(printf("{\"simulateIn\": \"%s\"}"))(arg_2);
        }
        case "renderer": {
            setSimulateInRenderer(true, dispatch_2);
            return "{\"simulateIn\": \"renderer\"}";
        }
        case "sidecar":
        case "dotnet":
        case "net": {
            setSimulateInRenderer(false, dispatch_2);
            return "{\"simulateIn\": \"sidecar\"}";
        }
        default:
            return toText(printf("{\"error\": \"no simulator called \'%s\' - say renderer or sidecar\"}"))(matchValue);
    }
}))], ["endWaveSim", (_arg_3) => ((_arg_4) => ((dispatch_3) => {
    dispatch_3(Msg.EndWaveSim);
    return "ended the waveform simulation";
}))], ["startWaveSim", (_arg_5) => ((model_1) => ((dispatch_4) => {
    refreshButtonAction(DrawModelType_SheetT_Model__Model_GetCanvasState(model_1.Sheet), model_1, dispatch_4, undefined);
    return "waveform simulation started";
}))], ["waveConfig", (arg_4) => ((_arg_6) => ((dispatch_5) => {
    let matchValue_1;
    let outArg = 0;
    matchValue_1 = [tryParse(arg_4, 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue_1[0]) {
        const n = matchValue_1[1] | 0;
        dispatch_5(new Msg(/* UpdateWSModel */ 13, [(ws) => {
            let bind$0040;
            return new WaveSimModel(ws.DefaultCursor, (bind$0040 = ws.WSConfig, new WSConfig_1(n, bind$0040.FirstClock, bind$0040.FontSize, bind$0040.FontWeight)), ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, ws.HoveredLabel, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected);
        }]));
        return `last clock set to ${n} - start the simulation for it to take effect`;
    }
    else {
        return concat("waveConfig needs a number of clock cycles, not \'", arg_4, "\'");
    }
}))], ["ramSelect", (arg_5) => ((model_2) => ((dispatch_6) => {
    let matchValue_2;
    let outArg_1 = 0;
    matchValue_2 = [tryParse(arg_5, 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
        outArg_1 = (v_1 | 0);
    })), outArg_1];
    if (matchValue_2[0]) {
        const ws_1 = getWSModel(model_2);
        const rams = truncate(matchValue_2[1], ws_1.RamComps);
        dispatch_6(new Msg(/* UpdateWSModel */ 13, [(ws_2) => (new WaveSimModel(ws_2.DefaultCursor, ws_2.WSConfig, ws_2.WSConfigDialog, ws_2.State, ws_2.WaveDetails, ws_2.SelectedWaves, ws_2.DefaultSelectionPending, ws_2.FetchFailedAtMs, ws_2.StartCycle, ws_2.ShownCycles, ws_2.SamplingZoom, ws_2.CursorDisplayCycle, ws_2.CursorExactClkCycle, ws_2.ClkCycleBoxIsEmpty, ws_2.Radix, ws_2.WaveformColumnWidth, ws_2.WaveModalActive, ws_2.RamModalActive, ws_2.PortSelectComp, ws_2.RamComps, ofList(rams, {
            Compare: (x, y) => (compareArrays(x, y) | 0),
        }), ws_2.RamStartLocation, ws_2.RamRows, ws_2.ShowSheetDetail, ws_2.SelectedSheetInstance, ws_2.ShowGroupDetail, ws_2.HoveredLabel, ws_2.DraggedIndex, ws_2.PrevSelectedWaves, ws_2.ScrollbarTbWidth, ws_2.ScrollbarTbPos, ws_2.ScrollbarTbOffset, ws_2.ScrollbarBkgWidth, ws_2.ScrollbarBkgRepCycs, ws_2.ScrollbarQueueIsEmpty, ws_2.SheetSearchString, ws_2.ComponentSearchString, ws_2.PortSearchString, ws_2.ShowOnlySelected))]));
        return `showing ${length(rams)} of ${length(ws_1.RamComps)} RAMs`;
    }
    else {
        return concat("ramSelect needs a number, not \'", arg_5, "\'");
    }
}))], ["waveSelect", (arg_6) => ((_arg_7) => ((dispatch_7) => {
    let array_1;
    const design = getFastSim().Design;
    const instances = (inst, sheet) => {
        const inst_1 = inst;
        return cons(inst_1, collect_1((tupledArg) => instances(cons(tupledArg[0], inst_1), tupledArg[1]), SimulatedDesign__SubSheetsOf_Z721C83C5(design, sheet)));
    };
    const all = collect_1((instance) => waveIndicesOfDesign(design, instance), instances(empty(), design.DesignTopSheet));
    const labelOf = (wave) => {
        let option_3, option_1;
        const patternInput = wave.Id;
        const sheet_1 = SimulatedDesign__SheetOfInstance_1A26531(design, patternInput[1]);
        return defaultArg((option_3 = ((option_1 = tryFind_1((ldc) => (ldc.Name === sheet_1), design.DesignSheets), (option_1 != null) ? tryFind_1((c) => equals(c.Id, patternInput[0]), option_1.CanvasState[0]) : undefined)), (option_3 != null) ? option_3.Label : undefined), "");
    };
    let patternInput_1;
    let matchValue_3;
    let outArg_2 = 0;
    matchValue_3 = [tryParse(arg_6, 511, false, 32, new FSharpRef(() => (outArg_2 | 0), (v_2) => {
        outArg_2 = (v_2 | 0);
    })), outArg_2];
    if (matchValue_3[0]) {
        patternInput_1 = [truncate(matchValue_3[1], all), empty()];
    }
    else {
        const found = map((n_3) => [n_3, filter((w) => (labelOf(w).toLocaleUpperCase() === n_3), all)], ofArray((array_1 = map_1((s) => s.trim().toLocaleUpperCase(), split(arg_6, [","], undefined, 0)), array_1.filter((y_1) => ("" !== y_1)))));
        patternInput_1 = [collect_1((tuple) => tuple[1], found), choose((tupledArg_1) => {
            if (isEmpty(tupledArg_1[1])) {
                return tupledArg_1[0];
            }
            else {
                return undefined;
            }
        }, found)];
    }
    const missing = patternInput_1[1];
    const chosen = patternInput_1[0];
    dispatch_7(new Msg(/* UpdateWSModel */ 13, [(ws_4) => (new WaveSimModel(ws_4.DefaultCursor, ws_4.WSConfig, ws_4.WSConfigDialog, ws_4.State, ws_4.WaveDetails, chosen, ws_4.DefaultSelectionPending, ws_4.FetchFailedAtMs, ws_4.StartCycle, ws_4.ShownCycles, ws_4.SamplingZoom, ws_4.CursorDisplayCycle, ws_4.CursorExactClkCycle, ws_4.ClkCycleBoxIsEmpty, ws_4.Radix, ws_4.WaveformColumnWidth, ws_4.WaveModalActive, ws_4.RamModalActive, ws_4.PortSelectComp, ws_4.RamComps, ws_4.SelectedRams, ws_4.RamStartLocation, ws_4.RamRows, ws_4.ShowSheetDetail, ws_4.SelectedSheetInstance, ws_4.ShowGroupDetail, ws_4.HoveredLabel, ws_4.DraggedIndex, ws_4.PrevSelectedWaves, ws_4.ScrollbarTbWidth, ws_4.ScrollbarTbPos, ws_4.ScrollbarTbOffset, ws_4.ScrollbarBkgWidth, ws_4.ScrollbarBkgRepCycs, ws_4.ScrollbarQueueIsEmpty, ws_4.SheetSearchString, ws_4.ComponentSearchString, ws_4.PortSearchString, ws_4.ShowOnlySelected))]));
    dispatch_7(Msg.GenerateCurrentWaveforms);
    if (isEmpty(missing)) {
        return `selected ${length(chosen)} waves`;
    }
    else {
        const have = join(", ", List_distinct(map(labelOf, all), {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: (x_2) => (stringHash(x_2) | 0),
        }));
        return (`selected ${length(chosen)}; nothing labelled ${join(", ", missing)}. `) + concat("This design has: ", have);
    }
}))], ["waveModal", (arg_7) => ((_arg_8) => ((dispatch_8) => {
    const opening = arg_7.trim().toLocaleLowerCase() !== "off";
    dispatch_8(new Msg(/* UpdateWSModel */ 13, [(ws_5) => (new WaveSimModel(ws_5.DefaultCursor, ws_5.WSConfig, ws_5.WSConfigDialog, ws_5.State, ws_5.WaveDetails, ws_5.SelectedWaves, ws_5.DefaultSelectionPending, ws_5.FetchFailedAtMs, ws_5.StartCycle, ws_5.ShownCycles, ws_5.SamplingZoom, ws_5.CursorDisplayCycle, ws_5.CursorExactClkCycle, ws_5.ClkCycleBoxIsEmpty, ws_5.Radix, ws_5.WaveformColumnWidth, opening, ws_5.RamModalActive, ws_5.PortSelectComp, ws_5.RamComps, ws_5.SelectedRams, ws_5.RamStartLocation, ws_5.RamRows, ws_5.ShowSheetDetail, ws_5.SelectedSheetInstance, ws_5.ShowGroupDetail, ws_5.HoveredLabel, ws_5.DraggedIndex, ws_5.PrevSelectedWaves, ws_5.ScrollbarTbWidth, ws_5.ScrollbarTbPos, ws_5.ScrollbarTbOffset, ws_5.ScrollbarBkgWidth, ws_5.ScrollbarBkgRepCycs, ws_5.ScrollbarQueueIsEmpty, ws_5.SheetSearchString, ws_5.ComponentSearchString, ws_5.PortSearchString, ws_5.ShowOnlySelected))]));
    return opening ? "Select Waves dialog opened" : "Select Waves dialog closed";
}))], ["ramModal", (arg_8) => ((_arg_9) => ((dispatch_9) => {
    const opening_1 = arg_8.trim().toLocaleLowerCase() !== "off";
    dispatch_9(new Msg(/* UpdateWSModel */ 13, [(ws_6) => (new WaveSimModel(ws_6.DefaultCursor, ws_6.WSConfig, ws_6.WSConfigDialog, ws_6.State, ws_6.WaveDetails, ws_6.SelectedWaves, ws_6.DefaultSelectionPending, ws_6.FetchFailedAtMs, ws_6.StartCycle, ws_6.ShownCycles, ws_6.SamplingZoom, ws_6.CursorDisplayCycle, ws_6.CursorExactClkCycle, ws_6.ClkCycleBoxIsEmpty, ws_6.Radix, ws_6.WaveformColumnWidth, ws_6.WaveModalActive, opening_1, ws_6.PortSelectComp, ws_6.RamComps, ws_6.SelectedRams, ws_6.RamStartLocation, ws_6.RamRows, ws_6.ShowSheetDetail, ws_6.SelectedSheetInstance, ws_6.ShowGroupDetail, ws_6.HoveredLabel, ws_6.DraggedIndex, ws_6.PrevSelectedWaves, ws_6.ScrollbarTbWidth, ws_6.ScrollbarTbPos, ws_6.ScrollbarTbOffset, ws_6.ScrollbarBkgWidth, ws_6.ScrollbarBkgRepCycs, ws_6.ScrollbarQueueIsEmpty, ws_6.SheetSearchString, ws_6.ComponentSearchString, ws_6.PortSearchString, ws_6.ShowOnlySelected))]));
    return opening_1 ? "Select RAM dialog opened" : "Select RAM dialog closed";
}))], ["truthTable", (_arg_10) => ((model_3) => ((dispatch_10) => {
    const ttDispatch = (msg) => {
        dispatch_10(new Msg(/* TruthTableMsg */ 32, [msg]));
    };
    let patternInput_2;
    const matchValue_4 = DrawModelType_SheetT_Model__Model_get_GetSelectedCanvasState(model_3.Sheet);
    let matchResult;
    if (isEmpty(matchValue_4[0])) {
        if (isEmpty(matchValue_4[1])) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const canvasState = DrawModelType_SheetT_Model__Model_GetCanvasState(model_3.Sheet);
            patternInput_2 = ["the whole sheet", simulateModel(true, false, undefined, 2, canvasState[0], canvasState[1], model_3)];
            break;
        }
        default:
            patternInput_2 = ["the selection", makeSimDataSelected(model_3)];
    }
    const scope = patternInput_2[0];
    const result = patternInput_2[1];
    if (result != null) {
        const copyOfStruct = result[0];
        if (copyOfStruct.tag === 0) {
            const res_1 = result;
            ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [res_1]));
            return concat("truth table generated for ", scope);
        }
        else {
            const res = result;
            setSimErrorFeedback(copyOfStruct.fields[0], model_3, dispatch_10);
            ttDispatch(new TTMsg(/* GenerateTruthTable */ 0, [res]));
            return `truth table for ${scope} failed: ${copyOfStruct.fields[0].ErrType}`;
        }
    }
    else {
        return "nothing to make a truth table from";
    }
}))], ["waveView", (arg_9) => ((_arg_11) => ((dispatch_11) => {
    let array_3;
    const parts = map_1((value_1) => (parse(value_1, 511, false, 32) | 0), (array_3 = split(arg_9, [" "], undefined, 0), array_3.filter((p) => (p !== ""))), Int32Array);
    if (!equalsWith((x_3, y_3) => (x_3 === y_3), parts, defaultOf()) && (parts.length === 0)) {
        return "waveView needs \'<startCycle> [shownCycles] [samplingZoom]\'";
    }
    else {
        dispatch_11(new Msg(/* UpdateWSModel */ 13, [(ws_7) => (new WaveSimModel(ws_7.DefaultCursor, ws_7.WSConfig, ws_7.WSConfigDialog, ws_7.State, ws_7.WaveDetails, ws_7.SelectedWaves, ws_7.DefaultSelectionPending, ws_7.FetchFailedAtMs, item_1(0, parts), (parts.length > 1) ? item_1(1, parts) : ws_7.ShownCycles, (parts.length > 2) ? item_1(2, parts) : ws_7.SamplingZoom, ws_7.CursorDisplayCycle, ws_7.CursorExactClkCycle, ws_7.ClkCycleBoxIsEmpty, ws_7.Radix, ws_7.WaveformColumnWidth, ws_7.WaveModalActive, ws_7.RamModalActive, ws_7.PortSelectComp, ws_7.RamComps, ws_7.SelectedRams, ws_7.RamStartLocation, ws_7.RamRows, ws_7.ShowSheetDetail, ws_7.SelectedSheetInstance, ws_7.ShowGroupDetail, ws_7.HoveredLabel, ws_7.DraggedIndex, ws_7.PrevSelectedWaves, ws_7.ScrollbarTbWidth, ws_7.ScrollbarTbPos, ws_7.ScrollbarTbOffset, ws_7.ScrollbarBkgWidth, ws_7.ScrollbarBkgRepCycs, ws_7.ScrollbarQueueIsEmpty, ws_7.SheetSearchString, ws_7.ComponentSearchString, ws_7.PortSearchString, ws_7.ShowOnlySelected))]));
        dispatch_11(Msg.GenerateCurrentWaveforms);
        return concat("view set to ", arg_9);
    }
}))], ["waveCursor", (arg_10) => ((model_4) => ((dispatch_12) => {
    let matchValue_5;
    let outArg_3 = 0;
    matchValue_5 = [tryParse(arg_10, 511, false, 32, new FSharpRef(() => (outArg_3 | 0), (v_3) => {
        outArg_3 = (v_3 | 0);
    })), outArg_3];
    if (matchValue_5[0]) {
        const n_5 = matchValue_5[1] | 0;
        dispatch_12(setClkCycleMsg(getWSModel(model_4), n_5));
        return `cursor to ${n_5}`;
    }
    else {
        return concat("waveCursor needs a number, not \'", arg_10, "\'");
    }
}))], ["rightTab", (arg_11) => ((_arg_12) => ((dispatch_13) => {
    switch (arg_11) {
        case "Catalogue": {
            dispatch_13(new Msg(/* ChangeRightTab */ 33, [RightTab.Catalogue]));
            return "Catalogue";
        }
        case "Properties": {
            dispatch_13(new Msg(/* ChangeRightTab */ 33, [RightTab.Properties]));
            return "Properties";
        }
        case "Simulation": {
            dispatch_13(new Msg(/* ChangeRightTab */ 33, [RightTab.Simulation]));
            return "Simulation";
        }
        case "Build": {
            dispatch_13(new Msg(/* ChangeRightTab */ 33, [RightTab.Build]));
            return "Build";
        }
        default:
            return concat("unknown tab \'", arg_11, "\': Catalogue | Properties | Simulation | Build");
    }
}))], ["simSubTab", (arg_12) => ((_arg_13) => ((dispatch_14) => {
    switch (arg_12) {
        case "StepSim": {
            dispatch_14(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.StepSim]));
            return "StepSim";
        }
        case "TruthTable": {
            dispatch_14(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.TruthTable]));
            return "TruthTable";
        }
        case "WaveSim": {
            dispatch_14(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.WaveSim]));
            return "WaveSim";
        }
        default:
            return concat("unknown sub-tab \'", arg_12, "\': StepSim | TruthTable | WaveSim");
    }
}))], ["openProject", (arg_13) => ((model_5) => ((dispatch_15) => {
    if (arg_13 === "") {
        return "openProject needs the path of a project folder";
    }
    else {
        openProjectFromPath(arg_13, model_5, dispatch_15);
        return concat("opening ", arg_13);
    }
}))], ["openSheet", (arg_14) => ((model_6) => ((dispatch_16) => {
    const matchValue_6 = model_6.CurrentProj;
    if (matchValue_6 != null) {
        if (!exists((l) => (l.Name === arg_14), matchValue_6.LoadedComponents)) {
            const project_1 = matchValue_6;
            return concat("no sheet \'", arg_14, "\' in this project");
        }
        else {
            const project_2 = matchValue_6;
            openFileInProject(arg_14, project_2, model_6, dispatch_16);
            return concat("opened ", arg_14);
        }
    }
    else {
        return "no project is open";
    }
}))], ["startSimulation", (_arg_14) => ((model_7) => ((dispatch_17) => {
    const canvasState_1 = DrawModelType_SheetT_Model__Model_GetCanvasState(model_7.Sheet);
    const _arg_15 = tryGetSimData(false, canvasState_1[0], canvasState_1[1], model_7);
    if (_arg_15.tag === 1) {
        const simError_1 = _arg_15.fields[0];
        dispatch_17(new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Error */ 1, [simError_1])]));
        return `simulation failed: ${simError_1.ErrType}`;
    }
    else {
        dispatch_17(new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Ok */ 0, [_arg_15.fields[0]])]));
        return "simulation started";
    }
}))], ["checkCircuit", (_arg_16) => ((_arg_17) => ((dispatch_18) => {
    dispatch_18(Msg.RunCircuitCheck);
    return "circuit check requested";
}))], ["copyAll", (_arg_18) => ((_arg_19) => ((dispatch_19) => {
    dispatch_19(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlA])]));
    dispatch_19(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlC])]));
    return "selected all and copied";
}))], ["select", (arg_15) => ((model_8) => ((dispatch_20) => {
    let wanted_1;
    const array_6 = map_1((s_1) => s_1.trim(), split(arg_15, [","], undefined, 0));
    wanted_1 = array_6.filter((s_2) => (s_2 !== ""));
    const symbols = model_8.Sheet.Wire.Symbol.Symbols;
    const byLabel = ofList(map((tupledArg_2) => [tupledArg_2[1].Component.Label.toLocaleUpperCase(), tupledArg_2[0]], toList_1(symbols)), {
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    });
    const patternInput_3 = partition(Result_IsOk, map((name_1) => {
        const matchValue_7 = tryFind(name_1.toLocaleUpperCase(), byLabel);
        if (matchValue_7 == null) {
            let matchValue_8;
            let outArg_4 = 0;
            matchValue_8 = [tryParse(name_1, 511, false, 32, new FSharpRef(() => (outArg_4 | 0), (v_4) => {
                outArg_4 = (v_4 | 0);
            })), outArg_4];
            let matchResult_1;
            if (matchValue_8[0]) {
                if (containsKey(matchValue_8[1], symbols)) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [matchValue_8[1]]);
                default:
                    return new FSharpResult$2(/* Error */ 1, [name_1]);
            }
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [matchValue_7]);
        }
    }, ofArray(wanted_1)));
    const missing_1 = patternInput_3[1];
    const ids = choose((_arg_20) => {
        if (_arg_20.tag === 1) {
            return undefined;
        }
        else {
            return _arg_20.fields[0];
        }
    }, patternInput_3[0]);
    dispatch_20(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* SelectComponents */ 32, [ids])]));
    if (isEmpty(missing_1)) {
        return `selected ${length(ids)}: ${arg_15}`;
    }
    else {
        const names = choose((_arg_21) => {
            if (_arg_21.tag === 0) {
                return undefined;
            }
            else {
                return _arg_21.fields[0];
            }
        }, missing_1);
        const have_1 = join(", ", map((tuple_1) => tuple_1[0], toList_1(byLabel)));
        return concat("no component labelled ", join(", ", names), " - this sheet has: ", have_1);
    }
}))], ["action", (arg_16) => ((_arg_22) => ((dispatch_21) => {
    const named = List_distinctBy((tuple_2) => tuple_2[0], map((spec) => [`${interpolate("%A%P()", [spec.Id])}`, spec.Id], shortcuts), {
        Equals: (x_5, y_5) => (x_5 === y_5),
        GetHashCode: (x_5) => (stringHash(x_5) | 0),
    });
    if (arg_16 === "") {
        return join(" ", sort(map((tuple_3) => tuple_3[0], named), {
            Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
        }));
    }
    else {
        const matchValue_9 = tryFind_1((tupledArg_3) => (tupledArg_3[0].toLocaleUpperCase() === arg_16.trim().toLocaleUpperCase()), named);
        if (matchValue_9 != null) {
            const name_3 = matchValue_9[0];
            actionOf(matchValue_9[1], dispatch_21);
            return concat("did ", name_3);
        }
        else {
            const near = filter((n_9) => (n_9.toLocaleUpperCase().indexOf(arg_16.trim().toLocaleUpperCase()) >= 0), map((tuple_4) => tuple_4[0], named));
            return isEmpty(near) ? concat("no shortcut called \'", arg_16, "\' - send \'action\' with no argument for the list") : (`no shortcut called '${arg_16}' - did you mean ${join(", ", near)}?`);
        }
    }
}))], ["move", (arg_17) => ((model_9) => ((dispatch_22) => {
    let parts_1;
    const array_8 = split(arg_17, [" "], undefined, 0);
    parts_1 = array_8.filter((s_3) => (s_3 !== ""));
    if (parts_1.length < 3) {
        return "move needs \'<label>[,<label>...] <dx> <dy>\'";
    }
    else {
        const byLabel_1 = ofList(map((tupledArg_4) => [tupledArg_4[1].Component.Label.toLocaleUpperCase(), tupledArg_4[0]], toList_1(model_9.Sheet.Wire.Symbol.Symbols)), {
            Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
        });
        const ids_1 = choose((n_10) => tryFind(n_10.trim().toLocaleUpperCase(), byLabel_1), ofArray(split(item_1(0, parts_1), [","], undefined, 0)));
        let matchValue_10;
        let outArg_5 = 0;
        matchValue_10 = [tryParse_1(item_1(1, parts_1), new FSharpRef(() => outArg_5, (v_5) => {
            outArg_5 = v_5;
        })), outArg_5];
        let matchValue_11;
        let outArg_6 = 0;
        matchValue_11 = [tryParse_1(item_1(2, parts_1), new FSharpRef(() => outArg_6, (v_6) => {
            outArg_6 = v_6;
        })), outArg_6];
        let matchResult_2;
        if (matchValue_10[0]) {
            if (matchValue_11[0]) {
                if (!isEmpty(ids_1)) {
                    matchResult_2 = 1;
                }
                else {
                    matchResult_2 = 2;
                }
            }
            else {
                matchResult_2 = 0;
            }
        }
        else {
            matchResult_2 = 0;
        }
        switch (matchResult_2) {
            case 0:
                return `move needs two numbers, not '${item_1(1, parts_1)}' and '${item_1(2, parts_1)}'`;
            case 1: {
                const dy_1 = matchValue_11[1];
                const dx_1 = matchValue_10[1];
                const delta = new XYPos(dx_1, dy_1);
                dispatch_22(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* MoveSymbols */ 7, [ids_1, delta])])])]));
                dispatch_22(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.UpdateBoundingBoxes]));
                dispatch_22(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* UpdateWires */ 7, [ids_1, delta])])]));
                dispatch_22(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.RerouteAllFloatingWires])]));
                return `moved ${length(ids_1)} by (${dx_1}, ${dy_1})`;
            }
            default:
                return concat("no component labelled ", item_1(0, parts_1));
        }
    }
}))], ["zoomToFit", (_arg_24) => ((_arg_25) => ((dispatch_23) => {
    dispatch_23(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlW])]));
    return "zoomed to fit the sheet in the window";
}))], ["pasteArray", (arg_18) => ((_arg_26) => ((dispatch_24) => {
    let parts_2;
    const array_10 = split(arg_18, [" "], undefined, 0);
    parts_2 = array_10.filter((s_4) => (s_4 !== ""));
    const intAt = (i, dflt, least) => {
        const matchValue_13 = tryItem(i, parts_2);
        if (matchValue_13 != null) {
            let matchValue_14;
            let outArg_7 = 0;
            matchValue_14 = [tryParse(matchValue_13, 511, false, 32, new FSharpRef(() => (outArg_7 | 0), (v_7) => {
                outArg_7 = (v_7 | 0);
            })), outArg_7];
            let matchResult_3;
            if (matchValue_14[0]) {
                if (matchValue_14[1] >= least) {
                    matchResult_3 = 0;
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
            switch (matchResult_3) {
                case 0:
                    return matchValue_14[1];
                default:
                    return undefined;
            }
        }
        else {
            return dflt;
        }
    };
    let direction;
    const matchValue_15 = tryItem(0, parts_2);
    let matchResult_4;
    if (matchValue_15 == null) {
        matchResult_4 = 1;
    }
    else {
        switch (matchValue_15) {
            case "horizontal": {
                matchResult_4 = 0;
                break;
            }
            case "vertical": {
                matchResult_4 = 1;
                break;
            }
            default:
                matchResult_4 = 2;
        }
    }
    switch (matchResult_4) {
        case 0: {
            direction = DrawModelType_SheetT_ArrayDirection.ArrayHorizontal;
            break;
        }
        case 1: {
            direction = DrawModelType_SheetT_ArrayDirection.ArrayVertical;
            break;
        }
        default:
            direction = undefined;
    }
    const matchValue_16 = intAt(1, 2, 2);
    const matchValue_17 = intAt(2, 0, 0);
    let matchResult_5, copies, dir, firstSuffix;
    if (direction != null) {
        if (matchValue_16 != null) {
            if (matchValue_17 != null) {
                matchResult_5 = 0;
                copies = matchValue_16;
                dir = direction;
                firstSuffix = matchValue_17;
            }
            else {
                matchResult_5 = 1;
            }
        }
        else {
            matchResult_5 = 1;
        }
    }
    else {
        matchResult_5 = 1;
    }
    switch (matchResult_5) {
        case 0: {
            const way = equals(dir, DrawModelType_SheetT_ArrayDirection.ArrayVertical) ? "vertical" : "horizontal";
            dispatch_24(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* PasteArray */ 37, [dir, copies, firstSuffix])]));
            return `pasting ${copies} copies as a ${way} array, suffixes from ${firstSuffix}`;
        }
        default:
            return "pasteArray takes <vertical|horizontal> <copies> [firstSuffix], copies being 2 or more and firstSuffix 0 or more";
    }
}))], ["benchmark", (arg_19) => ((model_10) => ((_arg_27) => {
    let option_8, option_11;
    let parts_3;
    const array_11 = split(arg_19, [" "], undefined, 0);
    parts_3 = array_11.filter((s_6) => (s_6 !== ""));
    const intAt_1 = (i_1, dflt_1) => {
        let outArg_8;
        let matchValue_19;
        const option_6 = tryItem(i_1, parts_3);
        matchValue_19 = ((option_6 != null) ? ((outArg_8 = 0, [tryParse(option_6, 511, false, 32, new FSharpRef(() => (outArg_8 | 0), (v_8) => {
            outArg_8 = (v_8 | 0);
        })), outArg_8])) : undefined);
        let matchResult_6, n_14;
        if (matchValue_19 != null) {
            if (matchValue_19[0]) {
                if (matchValue_19[1] > 0) {
                    matchResult_6 = 0;
                    n_14 = matchValue_19[1];
                }
                else {
                    matchResult_6 = 1;
                }
            }
            else {
                matchResult_6 = 1;
            }
        }
        else {
            matchResult_6 = 1;
        }
        switch (matchResult_6) {
            case 0:
                return n_14 | 0;
            default:
                return dflt_1 | 0;
        }
    };
    const steps = intAt_1(0, 100) | 0;
    const arraySize = intAt_1(1, Constants_maxArraySize) | 0;
    const canvasState_2 = DrawModelType_SheetT_Model__Model_GetCanvasState(model_10.Sheet);
    const matchValue_20 = startCircuitSimulation(arraySize, defaultArg((option_8 = model_10.CurrentProj, (option_8 != null) ? option_8.OpenFileName : undefined), ""), canvasState_2[0], canvasState_2[1], defaultArg((option_11 = model_10.CurrentProj, (option_11 != null) ? option_11.LoadedComponents : undefined), empty()));
    if (matchValue_20.tag === 0) {
        const simData_1 = matchValue_20.fields[0];
        lastBenchmarkSim = simData_1.FastSim;
        return timeRuns(simData_1.FastSim, steps);
    }
    else {
        return `{"error": "${matchValue_20.fields[0].ErrType}"}`;
    }
}))], ["rerun", (arg_21) => ((_arg_28) => ((_arg_29) => {
    let steps_1;
    let matchValue_21;
    let outArg_9 = 0;
    matchValue_21 = [tryParse(arg_21, 511, false, 32, new FSharpRef(() => (outArg_9 | 0), (v_9) => {
        outArg_9 = (v_9 | 0);
    })), outArg_9];
    let matchResult_7;
    if (matchValue_21[0]) {
        if (matchValue_21[1] > 0) {
            matchResult_7 = 0;
        }
        else {
            matchResult_7 = 1;
        }
    }
    else {
        matchResult_7 = 1;
    }
    switch (matchResult_7) {
        case 0: {
            steps_1 = matchValue_21[1];
            break;
        }
        default:
            steps_1 = 100;
    }
    return (lastBenchmarkSim != null) ? timeRuns(lastBenchmarkSim, steps_1) : "{\"error\": \"nothing built yet - send benchmark first\"}";
}))], ["sendDesign", (_arg_30) => ((model_11) => ((dispatch_25) => {
    sendDesignToSidecar(model_11, dispatch_25);
    return "{\"status\": \"sending - timings appear in the log\"}";
}))], ["simLog", (_arg_31) => ((_arg_32) => ((_arg_33) => recentJson()))], ["sidecarSimLog", (_arg_34) => ((_arg_35) => ((_arg_36) => {
    let pr;
    (pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (simLog().then((_arg_38) => {
        out(concat("sidecar simLog: ", _arg_38));
        return Promise.resolve();
    })))))), pr.catch((e_1) => {
        error(concat("sidecarSimLog: ", e_1.message));
    }));
    return "{\"status\": \"fetching - records appear in the log\"}";
}))], ["sidecarRun", (arg_22) => ((model_12) => ((dispatch_26) => {
    let parts_4;
    const array_12 = split(arg_22, [" "], undefined, 0);
    parts_4 = array_12.filter((s_7) => (s_7 !== ""));
    const intAt_2 = (i_2, dflt_2) => {
        let outArg_10;
        let matchValue_22;
        const option_14 = tryItem(i_2, parts_4);
        matchValue_22 = ((option_14 != null) ? ((outArg_10 = 0, [tryParse(option_14, 511, false, 32, new FSharpRef(() => (outArg_10 | 0), (v_10) => {
            outArg_10 = (v_10 | 0);
        })), outArg_10])) : undefined);
        let matchResult_8, n_18;
        if (matchValue_22 != null) {
            if (matchValue_22[0]) {
                if (matchValue_22[1] > 0) {
                    matchResult_8 = 0;
                    n_18 = matchValue_22[1];
                }
                else {
                    matchResult_8 = 1;
                }
            }
            else {
                matchResult_8 = 1;
            }
        }
        else {
            matchResult_8 = 1;
        }
        switch (matchResult_8) {
            case 0:
                return n_18 | 0;
            default:
                return dflt_2 | 0;
        }
    };
    runOnSidecarWithProgress(intAt_2(0, 1000000), intAt_2(1, 250), tryItem(2, parts_4), model_12, dispatch_26);
    return "{\"status\": \"running - progress bar up, report lands in the log\"}";
}))], ["localRun", (arg_24) => ((model_13) => ((dispatch_27) => {
    let name_4, pr_1;
    let parts_5;
    const array_13 = split(arg_24, [" "], undefined, 0);
    parts_5 = array_13.filter((s_8) => (s_8 !== ""));
    const intAt_3 = (i_3, dflt_3) => {
        let outArg_11;
        let matchValue_23;
        const option_16 = tryItem(i_3, parts_5);
        matchValue_23 = ((option_16 != null) ? ((outArg_11 = 0, [tryParse(option_16, 511, false, 32, new FSharpRef(() => (outArg_11 | 0), (v_11) => {
            outArg_11 = (v_11 | 0);
        })), outArg_11])) : undefined);
        let matchResult_9, n_20;
        if (matchValue_23 != null) {
            if (matchValue_23[0]) {
                if (matchValue_23[1] > 0) {
                    matchResult_9 = 0;
                    n_20 = matchValue_23[1];
                }
                else {
                    matchResult_9 = 1;
                }
            }
            else {
                matchResult_9 = 1;
            }
        }
        else {
            matchResult_9 = 1;
        }
        switch (matchResult_9) {
            case 0:
                return n_20 | 0;
            default:
                return dflt_3 | 0;
        }
    };
    const cycles = intAt_3(0, 1000000) | 0;
    const arraySize_1 = intAt_3(1, 250) | 0;
    const matchValue_24 = currentDesign(model_13);
    if (matchValue_24 != null) {
        const wholeDesign = matchValue_24[1];
        const ldcs_1 = matchValue_24[0];
        let design_1;
        const matchValue_25 = tryItem(2, parts_5);
        let matchResult_10, name_5;
        if (matchValue_25 != null) {
            if ((name_4 = matchValue_25, exists((ldc_2) => (ldc_2.Name === name_4), ldcs_1))) {
                matchResult_10 = 0;
                name_5 = matchValue_25;
            }
            else {
                matchResult_10 = 1;
            }
        }
        else {
            matchResult_10 = 1;
        }
        switch (matchResult_10) {
            case 0: {
                design_1 = (new SimpleDesign(name_5, wholeDesign.Sheets));
                break;
            }
            default:
                design_1 = wholeDesign;
        }
        const top = find((ldc_3) => (ldc_3.Name === design_1.TopSheet), ldcs_1);
        const started = getTimeMs();
        let matchValue_26;
        const tupledArg_5 = top.CanvasState;
        matchValue_26 = startCircuitSimulation(arraySize_1, design_1.TopSheet, tupledArg_5[0], tupledArg_5[1], ldcs_1);
        if (matchValue_26.tag === 0) {
            const fs_1 = matchValue_26.fields[0].FastSim;
            lastBenchmarkSim = fs_1;
            const chunk = (chunkCount) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                runFastSimulation(100, cycles, fs_1);
                if (fs_1.ClockTick < cycles) {
                    return (new Promise(resolve => setTimeout(resolve, 1))).then(() => (chunk(chunkCount + 1)));
                }
                else {
                    const ms = getTimeMs() - started;
                    out((`localRun: ${design_1.TopSheet} ${cycles} cycles in ${interpolate("%.0f%P()", [ms])}ms over ${chunkCount} chunks `) + (`(${interpolate("%.2f%P()", [cycles / ms])} cycles/ms) - see simLog for the per-chunk records`));
                    return Promise.resolve();
                }
            }));
            (pr_1 = chunk(1), pr_1.catch((e_3) => {
                error(concat("localRun: ", e_3.message));
            }));
            return "{\"status\": \"running locally - report lands in the log\"}";
        }
        else {
            return toText(printf("{\"error\": \"local build failed: %A\"}"))(matchValue_26.fields[0].ErrType);
        }
    }
    else {
        return "{\"error\": \"no project open\"}";
    }
}))], ["sidecarProbe", (arg_27) => ((model_14) => ((_arg_40) => {
    let pr_2;
    let cycles_1;
    let matchValue_27;
    let outArg_12 = 0;
    matchValue_27 = [tryParse(arg_27, 511, false, 32, new FSharpRef(() => (outArg_12 | 0), (v_12) => {
        outArg_12 = (v_12 | 0);
    })), outArg_12];
    let matchResult_11;
    if (matchValue_27[0]) {
        if (matchValue_27[1] > 1) {
            matchResult_11 = 0;
        }
        else {
            matchResult_11 = 1;
        }
    }
    else {
        matchResult_11 = 1;
    }
    switch (matchResult_11) {
        case 0: {
            cycles_1 = matchValue_27[1];
            break;
        }
        default:
            cycles_1 = 20;
    }
    const matchValue_28 = currentDesign(model_14);
    if (matchValue_28 != null) {
        const ldcs_2 = matchValue_28[0];
        const design_2 = matchValue_28[1];
        let matchValue_29;
        const tupledArg_6 = find((ldc_4) => (ldc_4.Name === design_2.TopSheet), ldcs_2).CanvasState;
        matchValue_29 = startCircuitSimulation(250, design_2.TopSheet, tupledArg_6[0], tupledArg_6[1], ldcs_2);
        if (matchValue_29.tag === 0) {
            const localFs = matchValue_29.fields[0].FastSim;
            runFastSimulation(undefined, cycles_1 - 1, localFs);
            const items = truncate(4, choose((fc) => {
                if ((isEmpty(fc.AccessPath) && (fc.Outputs.length > 0)) && (item_1(0, fc.Outputs).Width <= 32)) {
                    return [fc.cId, 0, empty()];
                }
                else {
                    return undefined;
                }
            }, ofArray(localFs.FCompsByIndex)));
            const sheetJsons = map((value_8) => Convert_serialize(value_8, createTypeInfo(SimpleSheet_$reflection())), design_2.Sheets);
            (pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (sendDesign(design_2.TopSheet, sheetJsons).then((_arg_42) => (simBuild(250).then((_arg_43) => {
                const built = _arg_43;
                const epoch = ((function (t) { try { return JSON.parse(t).epoch || 0 } catch (e) { return 0 } })(built)) | 0;
                return simRun(epoch, cycles_1 - 1, 0).then((_arg_44) => (simRead(epoch, 0, 1, cycles_1, items).then((_arg_45) => {
                    const frame = _arg_45;
                    const matchValue_30 = errorOfFrame(frame);
                    if (matchValue_30 == null) {
                        const count_1 = (length(items) * cycles_1) | 0;
                        const view = new Uint32Array(frame.buffer, frame.byteOffset + 24, count_1);
                        const mismatches = toList(delay(() => collect((itemIndex) => {
                            const cid_3 = item(itemIndex, items)[0] | 0;
                            return collect((c_2) => {
                                let matchValue_32;
                                const wire = view[((itemIndex * cycles_1) + c_2)];
                                let local;
                                const matchValue_31 = extractFastSimulationOutput(localFs, c_2, cid_3, empty(), 0);
                                local = ((matchValue_31.tag === 0) ? (toUInt32((matchValue_32 = matchValue_31.fields[0].Dat, (matchValue_32.tag === 1) ? matchValue_32.fields[0] : fromUInt32(matchValue_32.fields[0]))) >>> 0) : -1);
                                return (wire !== local) ? singleton_1(`comp ${cid_3} cycle ${c_2}: dotnet ${wire} vs electron ${local}`) : empty_1();
                            }, rangeDouble(0, 1, cycles_1 - 1));
                        }, rangeDouble(0, 1, length(items) - 1))));
                        if (!isEmpty(mismatches)) {
                            error(`sidecarProbe: ${length(mismatches)} mismatches, first: ${head(mismatches)}`);
                            return Promise.resolve();
                        }
                        else {
                            out((`sidecarProbe: IDENTICAL step data - ${length(items)} signals x ${cycles_1} cycles `) + "read through a zero-copy Uint32Array view over the 8-aligned frame");
                            return Promise.resolve();
                        }
                    }
                    else {
                        error(`sidecarProbe: SimRead failed: ${matchValue_30} (build: ${built})`);
                        return Promise.resolve();
                    }
                })));
            })))))))), pr_2.catch((e_6) => {
                error(concat("sidecarProbe: ", e_6.message));
            }));
            return "{\"status\": \"probing - verdict appears in the log\"}";
        }
        else {
            return toText(printf("{\"error\": \"local build failed: %A\"}"))(matchValue_29.fields[0].ErrType);
        }
    }
    else {
        return "{\"error\": \"no project open\"}";
    }
}))], ["sidecarPorts", (_arg_46) => ((model_15) => ((_arg_47) => {
    let pr_3;
    const matchValue_33 = currentDesign(model_15);
    if (matchValue_33 != null) {
        const ldcs_3 = matchValue_33[0];
        const design_3 = matchValue_33[1];
        let matchValue_34;
        const tupledArg_7 = find((ldc_5) => (ldc_5.Name === design_3.TopSheet), ldcs_3).CanvasState;
        matchValue_34 = startCircuitSimulation(250, design_3.TopSheet, tupledArg_7[0], tupledArg_7[1], ldcs_3);
        if (matchValue_34.tag === 0) {
            const localFs_1 = matchValue_34.fields[0].FastSim;
            const instances_1 = (inst_2, sheet_3) => {
                const inst_3 = inst_2;
                return cons(inst_3, collect_1((tupledArg_8) => instances_1(cons(tupledArg_8[0], inst_3), tupledArg_8[1]), SimulatedDesign__SubSheetsOf_Z721C83C5(localFs_1.Design, sheet_3)));
            };
            const all_1 = instances_1(empty(), design_3.TopSheet);
            const sheetJsons_1 = map((value_11) => Convert_serialize(value_11, createTypeInfo(SimpleSheet_$reflection())), design_3.Sheets);
            (pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (sendDesign(design_3.TopSheet, sheetJsons_1).then((_arg_49) => (simBuild(250).then((_arg_50) => {
                const epoch_1 = ((function (t) { try { return JSON.parse(t).epoch || 0 } catch (e) { return 0 } })(_arg_50)) | 0;
                let ports = 0;
                let failures = empty();
                const t0 = getTimeMs();
                return PromiseBuilder__For_1565554B(promise, all_1, (_arg_51) => {
                    const inst_4 = _arg_51;
                    return simPorts(epoch_1, map((_arg_52) => _arg_52, inst_4)).then((_arg_53) => {
                        const slice = _arg_53;
                        if (slice.tag === 0) {
                            const overTheWire = slice.fields[0];
                            const local_1 = sheetSliceOf(localFs_1, inst_4);
                            ports = ((ports + sumBy_1((c_4) => ((c_4.SlotsIns.length + c_4.SlotsOuts.length) | 0), overTheWire, {
                                GetZero: () => 0,
                                Add: (x_8, y_8) => ((x_8 + y_8) | 0),
                            })) | 0);
                            if (!equals(overTheWire, local_1)) {
                                failures = cons(`${inst_4}: slice differs`, failures);
                                return Promise.resolve();
                            }
                            else {
                                return Promise.resolve();
                            }
                        }
                        else {
                            failures = cons(`${inst_4}: ${slice.fields[0]}`, failures);
                            return Promise.resolve();
                        }
                    });
                }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    const ms_1 = getTimeMs() - t0;
                    if (!isEmpty(failures)) {
                        const first_1 = head(failures);
                        error(`sidecarPorts: ${length(failures)} failures, first: ${first_1}`);
                        return Promise.resolve();
                    }
                    else {
                        out(`sidecarPorts: IDENTICAL port slices - ${length(all_1)} instances, ${ports} ports, ${interpolate("%.1f%P()", [ms_1])}ms over the wire`);
                        return Promise.resolve();
                    }
                }));
            })))))))), pr_3.catch((e_9) => {
                error(concat("sidecarPorts: ", e_9.message));
            }));
            return "{\"status\": \"comparing - verdict appears in the log\"}";
        }
        else {
            return toText(printf("{\"error\": \"local build failed: %A\"}"))(matchValue_34.fields[0].ErrType);
        }
    }
    else {
        return "{\"error\": \"no project open\"}";
    }
}))], ["simCompare", (arg_30) => ((model_16) => ((_arg_54) => {
    let pr_4;
    let ticks;
    let matchValue_35;
    let outArg_13 = 0;
    matchValue_35 = [tryParse(arg_30, 511, false, 32, new FSharpRef(() => (outArg_13 | 0), (v_13) => {
        outArg_13 = (v_13 | 0);
    })), outArg_13];
    let matchResult_12;
    if (matchValue_35[0]) {
        if (matchValue_35[1] > 0) {
            matchResult_12 = 0;
        }
        else {
            matchResult_12 = 1;
        }
    }
    else {
        matchResult_12 = 1;
    }
    switch (matchResult_12) {
        case 0: {
            ticks = matchValue_35[1];
            break;
        }
        default:
            ticks = 30;
    }
    const matchValue_36 = currentDesign(model_16);
    if (matchValue_36 != null) {
        const design_4 = matchValue_36[1];
        const matchValue_37 = render(matchValue_36[0], design_4.TopSheet, ticks);
        if (matchValue_37.tag === 0) {
            const localText = matchValue_37.fields[0];
            const sheetJsons_2 = map((value_14) => Convert_serialize(value_14, createTypeInfo(SimpleSheet_$reflection())), design_4.Sheets);
            (pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => (sendDesign(design_4.TopSheet, sheetJsons_2).then((_arg_56) => {
                const t0_1 = getTimeMs();
                return simDigest(ticks).then((_arg_57) => {
                    const remote = _arg_57;
                    const ms_2 = getTimeMs() - t0_1;
                    if (remote.startsWith("{")) {
                        error(`simCompare: sidecar digest failed: ${remote} (design sent: ${_arg_56})`);
                        return Promise.resolve();
                    }
                    else if (remote === localText) {
                        out((`simCompare: IDENTICAL behaviour over ${ticks} cycles `) + (`(${localText.length} chars of digest; sidecar build+run+render ${interpolate("%.1f%P()", [ms_2])}ms)`));
                        return Promise.resolve();
                    }
                    else {
                        const localLines = split(localText, ["\n"], undefined, 0);
                        const remoteLines = split(remote, ["\n"], undefined, 0);
                        const firstDiff = head_1(append(map_2((tuple_5) => (tuple_5[0] | 0), filter_1((tupledArg_9) => {
                            const _arg_59 = tupledArg_9[1];
                            return _arg_59[0] !== _arg_59[1];
                        }, indexed(zip(localLines, remoteLines)))), singleton_1(min(localLines.length, remoteLines.length)))) | 0;
                        const at = (lines, i_4) => {
                            if (i_4 < lines.length) {
                                return item_1(i_4, lines);
                            }
                            else {
                                return "<missing>";
                            }
                        };
                        error((`simCompare: DIVERGED over ${ticks} cycles at digest line ${firstDiff}: `) + (`electron '${at(localLines, firstDiff)}' vs dotnet '${at(remoteLines, firstDiff)}'`));
                        return Promise.resolve();
                    }
                });
            })))))), pr_4.catch((e_11) => {
                error(concat("simCompare: ", e_11.message));
            }));
            return "{\"status\": \"comparing - verdict appears in the log\"}";
        }
        else {
            return toText(printf("{\"error\": \"local digest failed: %s\"}"))(matchValue_37.fields[0]);
        }
    }
    else {
        return "{\"error\": \"no project open\"}";
    }
}))]]);

function send(name, arg) {
    const latestModel_1 = latestModel;
    const latestDispatch_1 = latestDispatch;
    let matchResult, dispatch, model;
    if (latestModel_1 != null) {
        if (latestDispatch_1 != null) {
            matchResult = 0;
            dispatch = latestDispatch_1;
            model = latestModel_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_1 = tryFind_1((tupledArg) => (tupledArg[0] === name), commands);
            if (matchValue_1 == null) {
                return concat("unknown command \'", name, "\': try one of ", join(", ", map((tuple) => tuple[0], commands)));
            }
            else {
                return matchValue_1[1](arg)(model)(dispatch);
            }
        }
        default:
            return "the app has not finished starting";
    }
}

/**
 * Publish the harness. Debug builds only, by the same test the Development menu uses: this can
 * start simulations and open sheets, which is not something a shipped build should offer a page.
 */
export function publish(dispatch) {
    latestDispatch = dispatch;
    if (debugLevel() > 0) {
        window.issieDev = {
            commands: () => toArray(map((tuple) => tuple[0], commands)),
            onNextRender: (callback) => {
                onNextRender(callback);
            },
            send: send,
            sidecar: sidecar,
            simRefs: simRefs,
            simStats: simStats,
            state: state,
            waveState: waveState,
        };
    }
}

